function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg4Jobandplacement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 250 250)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(128,35,235)",
      fillOpacity: 0.15,
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 210
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(128,35,235)",
      fillOpacity: 0.4,
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 175
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(128,35,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 130
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.33 10.65)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-250.33, -260.65)",
    d: "M 239.083 329.917 L 224.708 316.792 C 209.986 303.319 196.688 289.951 184.813 276.688 C 172.938 263.424 167 248.806 167 232.833 C 167 219.778 171.375 208.875 180.125 200.125 C 188.875 191.375 199.778 187 212.833 187 C 220.194 187 227.139 188.563 233.667 191.688 C 240.194 194.813 245.75 199.083 250.333 204.5 C 254.917 199.083 260.472 194.813 267 191.688 C 273.528 188.563 280.472 187 287.833 187 C 300.889 187 311.792 191.375 320.542 200.125 C 329.292 208.875 333.667 219.778 333.667 232.833 C 333.667 248.806 327.764 263.458 315.958 276.792 C 304.153 290.125 290.75 303.528 275.75 317 L 261.583 329.917 C 258.389 332.833 254.639 334.292 250.333 334.292 C 246.028 334.292 242.278 332.833 239.083 329.917 Z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg4Jobandplacement);
export default __webpack_public_path__ + "static/media/img4_jobandplacement.c450de3f05da3e0e1c65888ee93e9d19.svg";
export { ForwardRef as ReactComponent };